'use client'

import { Dialog } from '@graftcode/design-system'

import {
  AnalyzerCommentsSection,
  MethodsSection,
  OutputSection,
  PreviewSection,
  QuickOptions,
  TypesSection,
  WizardActions,
  WizardHeader,
} from './components'
import { useGraftFilterWizard } from './hooks'
import type { GraftFilterWizardProps } from './types'

import styles from './GraftFilterWizard.module.scss'

export function GraftFilterWizard({ open, libraryData, onOpenChange }: GraftFilterWizardProps) {
  const wizard = useGraftFilterWizard({ open, libraryData, onOpenChange })

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      onDismiss={wizard.handleDismiss}
      maxWidth="44rem"
      className={styles.dialog}
      ariaLabelledBy="graft-filter-wizard-title"
    >
      <div className={styles.root}>
        <div className={styles.scrollable}>
          <WizardHeader />

          <QuickOptions {...wizard.quickOptions} />

          {wizard.report && wizard.report.issues.length > 0 && (
            <AnalyzerCommentsSection issues={wizard.report.issues} />
          )}

          <TypesSection {...wizard.types} />
          <MethodsSection {...wizard.methods} />
          {wizard.preview && <PreviewSection {...wizard.preview} />}
          <OutputSection {...wizard.output} />
        </div>

        <WizardActions onDismiss={wizard.handleDismiss} />
      </div>
    </Dialog>
  )
}
